import React, { Fragment } from 'react'
import { Grid, Paper, ListItem, MenuItem, Button, withStyles, Tooltip } from '@material-ui/core'

import {
  shopTypes,
  TimeZones,
  getCaStates,
  getUsStates,
  flowerTypes,
  Appcues,
  pennyTransactionOptions,
} from '../../utils/constants'

import { uploadAssetAPI } from '../../api/assets'
import EditActionComponent from '../common/EditActionComponent'
import {
  EditableTextField,
  EditableSelect,
  EditableReactSelectCreatable,
  EditableSwitch,
  EditableNumericInput,
} from '../common/EditableComponents'
import { connect } from 'react-redux'
import { EditableImageUploader, ImagePreview } from '../common/ImageUploader'
import Typography from '@material-ui/core/Typography/Typography'
import { globalValidator, checkEmail } from '../../utils/validations/common'
import { openErrorMessage, openSuccessMessage } from '../../actions/message'
import { hasAccess } from '../../utils/api'
import ReactPhoneInput from '../common/ReactPhoneInput'
import { getCompany, getCompanyFeatures } from '../../actions/company'
import { createMetrcLocation, getMetrcLocationTypes } from '../../actions/thirdParty'
import { getSynchronizedTeamsByShop } from '../../actions/integration'
import InfoIcon from '@material-ui/icons/Info'
import { getShopInformation, updateShopInformation } from '../../actions/shopInformation'
import { isFeatureFlagEnable } from '../../api/unleash'
import { UnleashToggles } from '../../types/unleashToggles'
import { CustomTooltip } from '../common/Tooltip'
import { ShopFeatureItem } from './ShopFeatureItem'

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 300,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}))(Tooltip)

const deviceTermTooltip = '• Device Terminal: The terminal of whoever is using the device.'
const assignedEmployeeTermTooltip =
  '• Assigned Employee Terminal: The terminal of the driver assigned to the transaction.'
const sellerTermTooltip =
  '• Seller Assigned Terminal: The terminal of whoever completes the transaction.'

const TermSalesTooltip = () => {
  return (
    <HtmlTooltip
      placement="right-start"
      title={
        <Typography color="inherit">
          <Fragment>
            This option will be used only for Retail, Retail App, and Delivery App.
            <br />
            {deviceTermTooltip}
            <br />
            {assignedEmployeeTermTooltip}
            <br />
            {sellerTermTooltip}
            <br />
          </Fragment>
        </Typography>
      }
    >
      <InfoIcon style={{ color: '#03a9f4' }} />
    </HtmlTooltip>
  )
}
class ShopInfo extends React.Component {
  componentDidMount = () => {
    isFeatureFlagEnable(UnleashToggles.SELLABLE_COMMITTED).then((res) => {
      this.setState({ isSellableCommittedEnabled: res })
    })

    this.props.dispatch(getCompanyFeatures())
    this.props.dispatch(getCompany())
    this.props.dispatch(getSynchronizedTeamsByShop({ shopId: this.props.data.id })).then((res) => {
      this.setState({
        onFleetTeamInfo: res || {},
      })
    })
    this.props.dispatch(getShopInformation('SHOP_INFORMATION')).then((res) => {
      this.setState({
        shopInfoSettings: res,
      })
    })
    this.props.dispatch(getShopInformation('COMPLIANCE')).then((res) => {
      this.setState({ complianceSettings: res })
    })
    isFeatureFlagEnable(UnleashToggles.TRIP_SHARE_INVENTORIES).then((res) => {
      this.setState({ tripShareInventoriesFlag: res })
    })
    this.getFlags()
  }

  getFlags = async () => {
    const canAutoArchiveBatches = await isFeatureFlagEnable(UnleashToggles.CAN_AUTO_ARCHIVE_BATCHES)
    this.setState({ canAutoArchiveBatchesFlag: canAutoArchiveBatches })
  }

  state = {
    creatingLocationMode: false,
    newLocationName: null,
    newLocationTypeName: null,
    shopInfoSettings: {
      enableAdultUse: false,
    },
    complianceSettings: {
      enableLimitV2: false,
      enableMetrcV2: false,
      refinishPackageResubmitTrans: false,
      useReceiptDetailsV2: false,
      allowSharedInventoriesTrip: false,
    },
    tripShareInventoriesFlag: false,
    canAutoArchiveBatchesFlag: false,
  }

  onChange = (key, isCheckBox) => (e) => {
    const value = isCheckBox ? e.target.checked : e.target.value
    if (!isCheckBox && 0 > value) {
      return
    }

    this.props.onChange(key, value)
  }

  updateShopInformation = (key, isCheckBox) => (e) => {
    const value = isCheckBox ? e.target.checked : e.target.value

    this.addEntryToShopInformation(key, value)
  }

  addEntryToShopInformation = (key, value) => {
    this.setState((prevState) => ({
      shopInfoSettings: {
        ...prevState.shopInfoSettings,
        [key]: value,
      },
    }))
  }

  onChangePhone = (e, key) => {
    this.props.onChange(key, e)
  }

  onSubmitMetrcPackageLocation = () => {
    const { newLocationName, newLocationTypeName } = this.state

    let valid = true
    valid =
      newLocationName && newLocationName != '' && newLocationTypeName && newLocationTypeName != ''

    //submit
    if (valid === true) {
      let data = {
        Name: newLocationName,
        LocationTypeName: newLocationTypeName,
      }
      this.props.dispatch(createMetrcLocation(data)).then((res) => {
        this.setState({
          creatingLocationMode: false,
        })
        this.props.onChange('defaultMetrcLocation', res)
        this.props.dispatch(openSuccessMessage('Shop Metrc default package created'))
        Appcues.track('Shop Metrc default package created')
      })
    } else {
      this.props.dispatch(openErrorMessage('Please enter a valid location and location type name'))
    }
  }

  retrieveLocationTypes = () => {
    Appcues.track('Retrieving Metrc Facilities')
    this.props.dispatch(getMetrcLocationTypes())
  }

  onSave = () => {
    this.cancelCreateLocation()
    const { data } = this.props
    const shopInformationData = JSON.stringify(this.state.shopInfoSettings)
    const complianceSettingData = JSON.stringify(this.state.complianceSettings)

    const keys = [
      { name: 'emailAdress', title: 'Email', validateKey: 'email' },
      { name: 'phoneNumber', title: 'Phone', validateKey: 'phone' },
    ]

    let valid = globalValidator(data, keys)

    if (data.legalLanguage && data.legalLanguage.length > 1000) {
      valid = 'The legal language for labels cannot be more than 1000 characters'
    }

    if (data.bccEmailAddress && data.bccEmailAddress.trim()) {
      const emailAddresses = data.bccEmailAddress.split(', ')
      for (let i = 0; i < emailAddresses.length; ++i) {
        if (!checkEmail(emailAddresses[i])) {
          valid = 'Please enter valid bcc email address'
          break
        }
      }
    }

    if (valid === true) {
      this.props.onSave((response) => {
        Appcues.track('Shop Info Saved')
        this.props.disableEdit()
      })
      this.props.dispatch(updateShopInformation(shopInformationData, 'SHOP_INFORMATION'))
      this.props.dispatch(updateShopInformation(complianceSettingData, 'COMPLIANCE'))
    } else {
      this.props.dispatch(openErrorMessage(valid))
    }
  }

  onCancel = () => {
    this.cancelCreateLocation()
    this.props.onCancel()
  }

  onChangeAddress = (key) => (e) => {
    const { data } = this.props
    const { address } = data

    let newAddress = { ...address }

    newAddress = {
      ...newAddress,
      [key]: e.target.value,
    }

    if (key === 'country') {
      newAddress = {
        ...newAddress,
        state: '',
      }
    }

    this.props.onChange('address', newAddress)
  }

  onChangeCreatableOptions = (key) => (values) => {
    let updatedValues =
      (values &&
        values.length &&
        values.map((value) => {
          return value.value
        })) ||
      []

    this.props.onChange(key, updatedValues)
  }

  onChangeEmailMessage = (key) => (value) => {
    this.props.onChange(key, value)
  }

  uploadShopLogo = (file, type, url) => {
    return new Promise((res, rej) => {
      uploadAssetAPI(file, 'photo/public').then((response) => {
        this.props.onChange('logo', response)
        res(response)
      })
    })
  }

  uploadEmailAttachment = (file, type, url) => {
    return new Promise((res, rej) => {
      uploadAssetAPI(file, 'photo/public').then((response) => {
        this.props.onChange('emailAttachment', response)
        res(response)
      })
    })
  }

  onChangeBccEmail = (value) => {
    this.props.onChange('bccEmailAddress', value)
  }

  onChangeNumber = (key) => (val) => {
    this.props.onChange(key, val)
  }

  toggleCreateLocation = () => {
    const creating = this.state.creatingLocationMode
    if (!creating) {
      //pull metrc location types
      this.retrieveLocationTypes()
    }
    this.setState({
      creatingLocationMode: !creating,
    })
  }

  cancelCreateLocation = () => {
    this.setState({ creatingLocationMode: false })
  }

  onChangeLocationType = (locationType) => (e) => {
    let target = e.target.value

    if (target && target != '') {
      this.setState({
        newLocationTypeName: target,
      })
    }
  }

  onChangeLocation = (location) => (e) => {
    let target = e.target.value || ''
    this.setState({
      newLocationName: target,
    })
  }

  updateComplianceSettings = (key, isCheckBox) => (e) => {
    const value = isCheckBox ? e.target.checked : e.target.value

    this.addEntryToComplianceSettings(key, value)
  }

  addEntryToComplianceSettings = (key, value) => {
    this.setState((prevState) => ({
      complianceSettings: {
        ...prevState.complianceSettings,
        [key]: value,
      },
    }))
  }

  render() {
    const {
      editMode = false,
      data = {},
      terminals = {},
      companyReducer = {},
      authReducer = {},
      onCreateLoc,
    } = this.props

    const { metrcLocationTypes = [] } = this.props.thirdPartyReducer

    const role =
      authReducer.session && authReducer.session.employee && authReducer.session.employee.role
    const internal =
      authReducer.session && authReducer.session.employee && authReducer.session.employee.internal
    const { assignedShop } = authReducer.session
    const allowDelivery = assignedShop && assignedShop.allowDelivery

    const {
      creatingLocationMode = false,
      newLocationTypeName,
      newLocationName,
      onFleetTeamInfo = {},
      shopInfoSettings,
      isSellableCommittedEnabled,
      complianceSettings,
      tripShareInventoriesFlag,
      canAutoArchiveBatchesFlag,
    } = this.state

    const { companyFeatures = {}, committedConfig = {}, company = {} } = companyReducer
    const globalValidationEnabled = committedConfig['committedValidationEnabled'] || false
    const { availableApps = [] } = companyFeatures || {}

    const isShop = data && data.id ? true : false

    const label = data.address && data.address.country === 'CA' ? 'Province' : 'State'

    const states = label === 'Province' ? getCaStates() : getUsStates()

    let queueTypes = [
      {
        name: 'Walkin',
        show: 'showWalkInQueue',
        dov: 'walkInQueueDOV',
      },
      {
        name: 'Special',
        show: 'showSpecialQueue',
        dov: 'specialQueueDOV',
      },
    ]
    if (allowDelivery) {
      queueTypes.splice(0, 0, {
        name: 'Delivery',
        show: 'showDeliveryQueue',
        dov: 'deliveryQueueDOV',
      })
    }

    const editModeClass = editMode ? 'editable_field' : ''

    const isGrowShop = data.appTarget === 'Grow'
    const isMedicinalShop = data.shopType === 'Medicinal'
    const showConsumerTypeRestriction = companyReducer.companyFeatures.showConsumerTypeRestriction

    const defaultPennyTransactionOption = pennyTransactionOptions[0]
    const pennyTransactionOptionValue =
      pennyTransactionOptions.find((option) => option.value === data.pennyTransactionOption) ||
      defaultPennyTransactionOption

    const productInfoSourcingStrategyLabels = {
      NONE: 'Disabled',
      MANUAL: 'Manual',
      FIFO_BATCH: 'FIFO',
      LIFO_BATCH: 'LIFO',
    }
    const productInfoSourcingStrategyValue = data.productInfoSourcingStrategy || 'NONE'

    const onFleetTeamInfoList = onFleetTeamInfo.onFleetTeamInfoList || []
    const onFleetTeam = onFleetTeamInfoList.find((team) => team.id == data.autoOnFleetTeam)

    return (
      <div>
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            {hasAccess() ? (
              <div className="pull-right margin-bottom-small">
                <EditActionComponent
                  onSave={this.onSave}
                  onCancel={this.onCancel}
                  onEdit={this.props.enableEdit}
                  editMode={editMode}
                />
              </div>
            ) : (
              <div className="pull-right margin-bottom-small"></div>
            )}
          </Grid>
          <Grid className={`shopInfo ${editModeClass}`} container>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Paper className="paper-page">
                {isShop && (
                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                        Internal ID
                      </Grid>
                      <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                        <EditableTextField
                          valueToRender={data.id || ''}
                          editMode={false}
                          value={data.id || ''}
                          type="text"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                )}
                <ListItem>
                  <Grid container>
                    <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                      Shop Name
                    </Grid>
                    <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                      <EditableTextField
                        valueToRender={data.name}
                        editMode={editMode}
                        value={data.name}
                        onChange={this.onChange('name')}
                        type="text"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                  </Grid>
                </ListItem>
                <ListItem>
                  <Grid container>
                    <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                      Shop Type
                    </Grid>
                    <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                      <EditableSelect
                        value={data.shopType}
                        onChange={this.onChange('shopType')}
                        valueToRender={data.shopType}
                        editMode={editMode}
                      >
                        {shopTypes.map((shopType, index) => {
                          return (
                            <MenuItem key={index} value={shopType.value}>
                              {shopType.label}
                            </MenuItem>
                          )
                        })}
                      </EditableSelect>
                    </Grid>
                  </Grid>
                </ListItem>
                <ListItem>
                  <Grid container>
                    <Grid className="labelField" xs={12} sm={6} md={6} item lg={6}>
                      Shop Logo
                    </Grid>
                    <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                      <EditableImageUploader
                        editMode={editMode}
                        valueToRender={<ImagePreview src={data.logo && data.logo.thumbURL} />}
                        src={data.logo && data.logo.thumbURL}
                        imageUploadAPI={this.uploadShopLogo}
                      />
                    </Grid>
                  </Grid>
                </ListItem>
                <ListItem>
                  <Grid container>
                    <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                      Shop Website
                    </Grid>
                    <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                      <EditableTextField
                        valueToRender={data.website}
                        editMode={editMode}
                        value={data.website}
                        onChange={this.onChange('website')}
                        type="text"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                  </Grid>
                </ListItem>
                <ListItem>
                  <Grid container>
                    <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                      Email
                    </Grid>
                    <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                      <EditableTextField
                        valueToRender={data.emailAdress}
                        editMode={editMode}
                        value={data.emailAdress}
                        onChange={this.onChange('emailAdress')}
                        type="text"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                  </Grid>
                </ListItem>
                <ListItem>
                  <Grid container>
                    <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                      Phone
                    </Grid>
                    <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                      {editMode ? (
                        <ReactPhoneInput
                          defaultCountry={'us'}
                          placeholder={'Phone Number'}
                          onChange={(e) => this.onChangePhone(e, 'phoneNumber')}
                          preferredCountries={['us', 'ca']}
                          inputClass="global-phone-input"
                          name="phoneNumber"
                          value={(data && data.phoneNumber) || ''}
                          containerClass="form-control phone-input"
                        />
                      ) : (
                        `${data && data.phoneNumber}`
                      )}
                    </Grid>
                  </Grid>
                </ListItem>
                <ListItem>
                  <Grid container>
                    <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                      Shop License
                    </Grid>
                    <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                      {internal ? (
                        <EditableTextField
                          valueToRender={data.license}
                          editMode={editMode}
                          value={data.license}
                          onChange={this.onChange('license')}
                          type="text"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      ) : (
                        <div>{data.license}</div>
                      )}
                    </Grid>
                  </Grid>
                </ListItem>
                <ListItem>
                  <Grid container>
                    <Grid className="labelField flex-center" item xs={12} sm={6} md={6} lg={6}>
                      DEA Number &nbsp;
                      <CustomTooltip
                        message={'Only enter if DEA number is required in your state'}
                      />
                    </Grid>
                    <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                      <EditableTextField
                        valueToRender={data.deaNumber}
                        editMode={editMode}
                        value={data.deaNumber}
                        onChange={this.onChange('deaNumber')}
                        type="text"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                  </Grid>
                </ListItem>
              </Paper>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Paper className="paper-page">
                <ListItem>
                  <Grid container>
                    <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                      Country
                    </Grid>
                    <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                      <EditableSelect
                        value={data.address && data.address.country}
                        onChange={this.onChangeAddress('country')}
                        valueToRender={data.address && data.address.country}
                        editMode={editMode}
                        displayEmpty={true}
                      >
                        <MenuItem value="">Select Country</MenuItem>
                        <MenuItem value={'US'}>United States</MenuItem>
                        <MenuItem value={'CA'}>Canada</MenuItem>
                      </EditableSelect>
                    </Grid>
                  </Grid>
                </ListItem>
                <ListItem>
                  <Grid container>
                    <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                      Address
                    </Grid>
                    <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                      <EditableTextField
                        valueToRender={data.address && data.address.address}
                        editMode={editMode}
                        value={data.address && data.address.address}
                        onChange={this.onChangeAddress('address')}
                        type="text"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                  </Grid>
                </ListItem>
                <ListItem>
                  <Grid container>
                    <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                      City
                    </Grid>
                    <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                      <EditableTextField
                        valueToRender={data.address && data.address.city}
                        editMode={editMode}
                        value={data.address && data.address.city}
                        onChange={this.onChangeAddress('city')}
                        type="text"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                  </Grid>
                </ListItem>
                <ListItem>
                  <Grid container>
                    <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                      Zip Code
                    </Grid>
                    <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                      <EditableTextField
                        valueToRender={data.address && data.address.zipCode}
                        editMode={editMode}
                        value={data.address && data.address.zipCode}
                        onChange={this.onChangeAddress('zipCode')}
                        type="text"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                  </Grid>
                </ListItem>
                <ListItem>
                  <Grid container>
                    <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                      {label}
                    </Grid>
                    <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                      <EditableSelect
                        value={data.address && data.address.state}
                        onChange={this.onChangeAddress('state')}
                        valueToRender={data.address && data.address.state}
                        editMode={editMode}
                        displayEmpty={true}
                      >
                        <MenuItem value="">Select {label}</MenuItem>
                        {states &&
                          states.length &&
                          states.map((state, index) => {
                            return (
                              <MenuItem value={state.value} key={index}>
                                {state.label}
                              </MenuItem>
                            )
                          })}
                      </EditableSelect>
                    </Grid>
                  </Grid>
                </ListItem>
                <ListItem>
                  <Grid container>
                    <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                      Time Zone
                    </Grid>
                    <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                      <EditableSelect
                        value={data.timeZone}
                        onChange={this.onChange('timeZone')}
                        valueToRender={data.timeZone}
                        editMode={editMode}
                        displayEmpty={true}
                      >
                        <MenuItem value={''}>Select TimeZone</MenuItem>
                        {TimeZones.map((timezone, index) => {
                          return (
                            <MenuItem key={index} value={timezone.value}>
                              {timezone.label}
                            </MenuItem>
                          )
                        })}
                      </EditableSelect>
                    </Grid>
                  </Grid>
                </ListItem>
                <ListItem>
                  <Grid container>
                    <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                      Marketing Sources
                    </Grid>
                    <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                      <EditableReactSelectCreatable
                        multi={true}
                        value={data.marketingSources}
                        onChange={this.onChangeCreatableOptions('marketingSources')}
                        valueToRender={
                          data.marketingSources &&
                          data.marketingSources.length &&
                          data.marketingSources.join()
                        }
                        editMode={editMode}
                        options={
                          data.marketingSources &&
                          data.marketingSources.map((source) => ({
                            label: source,
                            value: source,
                          }))
                        }
                        clearable={false}
                      />
                    </Grid>
                  </Grid>
                </ListItem>
                <ListItem>
                  <Grid container>
                    <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                      Product Tags
                    </Grid>
                    <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                      <EditableReactSelectCreatable
                        multi={true}
                        value={data.productsTag}
                        onChange={this.onChangeCreatableOptions('productsTag')}
                        valueToRender={
                          data.productsTag && data.productsTag.length && data.productsTag.join()
                        }
                        editMode={editMode}
                        options={
                          data.productsTag &&
                          data.productsTag.map((tag) => ({
                            label: tag,
                            value: tag,
                          }))
                        }
                        clearable={false}
                      />
                    </Grid>
                  </Grid>
                </ListItem>
                <ListItem>
                  <Grid container>
                    <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                      Order Tags
                    </Grid>
                    <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                      <EditableReactSelectCreatable
                        multi={true}
                        value={data.orderTags}
                        onChange={this.onChangeCreatableOptions('orderTags')}
                        valueToRender={
                          (data.orderTags && data.orderTags.length && data.orderTags.join(', ')) ||
                          ''
                        }
                        editMode={editMode}
                        options={
                          data.orderTags &&
                          data.orderTags.map((tag) => ({
                            label: tag,
                            value: tag,
                          }))
                        }
                        clearable={false}
                      />
                    </Grid>
                  </Grid>
                </ListItem>
                {data.appTarget !== 'Grow' && (
                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                        Member Tags
                      </Grid>
                      <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                        <EditableReactSelectCreatable
                          multi={true}
                          value={data.membersTag}
                          onChange={this.onChangeCreatableOptions('membersTag')}
                          valueToRender={
                            (data.membersTag &&
                              data.membersTag.length &&
                              data.membersTag.join(', ')) ||
                            ''
                          }
                          editMode={editMode}
                          options={
                            data.membersTag &&
                            data.membersTag.map((tag) => ({
                              label: tag,
                              value: tag,
                            }))
                          }
                          clearable={false}
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                )}
                <ListItem>
                  <Grid container>
                    <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                      Flower Types
                    </Grid>
                    <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                      <EditableReactSelectCreatable
                        multi={true}
                        value={data.flowerType}
                        onChange={this.onChangeCreatableOptions('flowerType')}
                        valueToRender={
                          (data.flowerType &&
                            data.flowerType.length &&
                            data.flowerType.join(', ')) ||
                          ''
                        }
                        editMode={editMode}
                        options={(
                          data.flowerType &&
                          data.flowerType.map((type) => ({
                            label: type,
                            value: type,
                          }))
                        ).concat(flowerTypes || [])}
                        clearable={false}
                      />
                    </Grid>
                  </Grid>
                </ListItem>
              </Paper>
            </Grid>
            {data.appTarget !== 'Grow' && (
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Paper className="paper-page">
                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                        Cash Round Off Type
                      </Grid>
                      <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                        <EditableSelect
                          value={data.taxRoundOffType}
                          onChange={this.onChange('taxRoundOffType')}
                          valueToRender={data.taxRoundOffType}
                          editMode={editMode}
                          displayEmpty={true}
                        >
                          <MenuItem value="">Select Round Off Type</MenuItem>
                          <MenuItem value="ONE_CENT">One Cent</MenuItem>
                          <MenuItem value="FIVE_CENT">Five Cents</MenuItem>
                          <MenuItem value="NEAREST_DOLLAR">Nearest Dollar</MenuItem>
                          <MenuItem value="UP_DOLLAR">Up Dollar</MenuItem>
                          <MenuItem value="DOWN_DOLLAR">Down Dollar</MenuItem>
                        </EditableSelect>
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                        Purchase Floor of a Penny
                      </Grid>
                      <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                        <EditableSelect
                          value={data.pennyTransactionOption || defaultPennyTransactionOption.value}
                          onChange={this.onChange('pennyTransactionOption')}
                          valueToRender={pennyTransactionOptionValue.label}
                          editMode={editMode}
                          displayEmpty={true}
                        >
                          {pennyTransactionOptions.map((option, index) => {
                            return (
                              <MenuItem key={index} value={option.value}>
                                {option.label}
                              </MenuItem>
                            )
                          })}
                        </EditableSelect>
                      </Grid>
                    </Grid>
                  </ListItem>

                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}></Grid>
                      <Grid className="editField" item xs={12} sm={2} md={2} lg={1}></Grid>
                      <Grid className="editField" item xs={12} sm={4} md={4} lg={5}>
                        <span>
                          When enabled all cannabis transactions will have a charge of at least one
                          cent.
                        </span>
                      </Grid>
                    </Grid>
                  </ListItem>

                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                        Cash Drawer
                      </Grid>
                      <Grid className="editField switch_btn" item xs={12} sm={2} md={2} lg={1}>
                        <EditableSwitch
                          valueToRender={data.enablePinForCashDrawer ? 'Enabled' : 'Disabled'}
                          checked={data.enablePinForCashDrawer}
                          editMode={editMode}
                          onChange={this.onChange('enablePinForCashDrawer', true)}
                        />
                      </Grid>
                      <Grid className="editField" item xs={12} sm={4} md={4} lg={5}>
                        <span>
                          When enabled, the manager will be required to enter the pin to open cash
                          drawer
                        </span>
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                        Enable Tips for BLAZEPAY
                      </Grid>
                      <Grid className="editField switch_btn" item xs={12} sm={2} md={2} lg={1}>
                        <EditableSwitch
                          valueToRender={data.enableTipsBlazePay ? 'Enabled' : 'Disabled'}
                          checked={data.enableTipsBlazePay}
                          editMode={editMode}
                          onChange={this.onChange('enableTipsBlazePay', true)}
                        />
                      </Grid>
                      <Grid className="editField" item xs={12} sm={4} md={4} lg={5}>
                        <span>When enabled, tip is requested from the customer</span>
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                        User Cannabis Limit
                      </Grid>
                      <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                        <EditableSwitch
                          valueToRender={data.enableCannabisLimit ? 'Enabled' : 'Disabled'}
                          checked={data.enableCannabisLimit}
                          editMode={editMode}
                          onChange={this.onChange('enableCannabisLimit', true)}
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                  {role && role.name === 'Admin' && (
                    <ListItem>
                      <Grid container>
                        <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                          Override Member Levels
                        </Grid>
                        <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                          <EditableSwitch
                            valueToRender={data.overrideMemberLimits ? 'Enabled' : 'Disabled'}
                            checked={data.overrideMemberLimits}
                            editMode={editMode}
                            onChange={this.onChange('overrideMemberLimits', true)}
                          />
                        </Grid>
                      </Grid>
                    </ListItem>
                  )}

                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                        Enable Recreational Age Limit
                      </Grid>
                      <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                        <EditableSwitch
                          valueToRender={data.enableAgeLimit ? 'Enabled' : 'Disabled'}
                          checked={data.enableAgeLimit}
                          editMode={editMode}
                          onChange={this.onChange('enableAgeLimit', true)}
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                  {data.enableAgeLimit ? (
                    <ListItem>
                      <Grid container>
                        <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                          Recreational Use Age Limit
                        </Grid>
                        <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                          <EditableTextField
                            valueToRender={data.ageLimit || ''}
                            value={data.ageLimit || ''}
                            editMode={editMode}
                            onChange={this.onChange('ageLimit')}
                          />
                        </Grid>
                      </Grid>
                    </ListItem>
                  ) : null}
                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                        Enable Medicinal Age Limit
                      </Grid>
                      <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                        <EditableSwitch
                          valueToRender={data.enableMedicinalAge ? 'Enabled' : 'Disabled'}
                          checked={data.enableMedicinalAge}
                          editMode={editMode}
                          onChange={this.onChange('enableMedicinalAge', true)}
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                  {data.enableMedicinalAge ? (
                    <ListItem>
                      <Grid container>
                        <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                          Medicinal Use Age Limit
                        </Grid>
                        <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                          <EditableTextField
                            valueToRender={data.medicinalAge || ''}
                            value={data.medicinalAge || ''}
                            editMode={editMode}
                            onChange={this.onChange('medicinalAge')}
                          />
                        </Grid>
                      </Grid>
                    </ListItem>
                  ) : null}
                  {data.address && data.address.state === 'MA' ? (
                    <ListItem>
                      <Grid container>
                        <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                          Enable Limit On Net Weight
                        </Grid>
                        <Grid className="editField switch_btn" item xs={12} sm={2} md={2} lg={1}>
                          <EditableSwitch
                            valueToRender={data.enableLimitOnNetWeight ? 'Enabled' : 'Disabled'}
                            checked={data.enableLimitOnNetWeight}
                            editMode={editMode}
                            onChange={this.onChange('enableLimitOnNetWeight', true)}
                          />
                        </Grid>
                        <Grid className="editField" item xs={12} sm={4} md={4} lg={5}>
                          <span>
                            When enabled, the limits for Concentrates & Tinctures will be calculated
                            by the Net Weight of the product instead of the active THC content of
                            the product.
                          </span>
                        </Grid>
                      </Grid>
                    </ListItem>
                  ) : null}
                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                        Disable Medical Products for Adult Use
                      </Grid>
                      <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                        <EditableSwitch
                          valueToRender={
                            data.disableMedicalProductsForAdultUse ? 'Enabled' : 'Disabled'
                          }
                          checked={data.disableMedicalProductsForAdultUse}
                          editMode={editMode}
                          onChange={this.onChange('disableMedicalProductsForAdultUse', true)}
                        />
                      </Grid>
                    </Grid>
                  </ListItem>

                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                        Hide Products with Zero Inventory
                      </Grid>
                      <Grid className="editField" item xs={12} sm={2} md={2} lg={1}>
                        <EditableSwitch
                          valueToRender={
                            data.showProductByAvailableQuantity ? 'Enabled' : 'Disabled'
                          }
                          checked={data.showProductByAvailableQuantity}
                          editMode={editMode}
                          onChange={this.onChange('showProductByAvailableQuantity', true)}
                        />
                      </Grid>
                      <Grid className="editField" item xs={12} sm={4} md={4} lg={5}>
                        <span>
                          When enabled, products with inventory greater than 0 will be displayed.
                        </span>
                      </Grid>
                    </Grid>
                  </ListItem>

                  {canAutoArchiveBatchesFlag && (
                    <>
                      <ShopFeatureItem
                        label={'Auto-archive Batches'}
                        value={data.autoArchiveBatches}
                        editMode={editMode}
                        onChange={(event) => this.onChange('autoArchiveBatches', true)(event)}
                        description={
                          'When enabled, all batches with 0 quantity will be automatically archived nightly.'
                        }
                      />
                      {data.autoArchiveBatches && (
                        <ShopFeatureItem
                          label={''}
                          value={data.autoArchiveBatchesAfterNDays}
                          editMode={editMode}
                          onChange={(event) =>
                            this.onChange('autoArchiveBatchesAfterNDays', false)(event)
                          }
                          description={'Archive period, in days, for zero-quantity batches.'}
                          type="numeric"
                          max={999}
                        />
                      )}
                    </>
                  )}

                  {isSellableCommittedEnabled && (
                    <ListItem>
                      <Grid container>
                        <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                          Enable Sellable Committed Validation
                        </Grid>
                        <Grid className="editField" item xs={12} sm={2} md={2} lg={1}>
                          <EditableSwitch
                            valueToRender={data.enableCommittedValidation ? 'Enabled' : 'Disabled'}
                            checked={data.enableCommittedValidation}
                            editMode={editMode}
                            onChange={this.onChange('enableCommittedValidation', true)}
                          />
                        </Grid>
                        <Grid
                          className="editField"
                          item
                          xs={12}
                          sm={4}
                          md={4}
                          lg={5}
                          style={{ wordBreak: 'break-word' }}
                        >
                          <span>When enabled, committed inventory will be validated</span>
                        </Grid>
                      </Grid>
                    </ListItem>
                  )}
                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                        Active Orders per Member
                      </Grid>
                      <Grid className="editField order_per_month" item xs={12} sm={2} md={2} lg={1}>
                        <EditableSelect
                          value={data.numAllowActiveTrans || 1}
                          onChange={this.onChange('numAllowActiveTrans')}
                          valueToRender={data.numAllowActiveTrans || 1}
                          editMode={editMode}
                          displayEmpty={true}
                        >
                          <MenuItem value={1}>One</MenuItem>
                          <MenuItem value={2}>Two</MenuItem>
                          <MenuItem value={3}>Three</MenuItem>
                          <MenuItem value={4}>Four</MenuItem>
                          <MenuItem value={5}>Five</MenuItem>
                          <MenuItem value={6}>Six</MenuItem>
                          <MenuItem value={7}>Seven</MenuItem>
                          <MenuItem value={8}>Eight</MenuItem>
                          <MenuItem value={9}>Nine</MenuItem>
                          <MenuItem value={10}>Ten</MenuItem>
                        </EditableSelect>
                      </Grid>
                      <Grid className="editField" item xs={12} sm={4} md={4} lg={5}>
                        <span>
                          Specifies the number of simultaneous allowed active orders per members.
                        </span>
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                        Require member’s phone number
                      </Grid>
                      <Grid className="editField order_per_month" item xs={12} sm={6} md={6} lg={6}>
                        <EditableSwitch
                          checked={data.requiredMemberPhone}
                          onChange={this.onChange('requiredMemberPhone', true)}
                          valueToRender={data.requiredMemberPhone ? 'Enabled' : 'Disabled'}
                          editMode={editMode}
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                        Allow Anonymous Orders
                      </Grid>
                      <Grid className="editField order_per_month" item xs={12} sm={6} md={6} lg={6}>
                        <EditableSwitch
                          checked={data.allowAnonymousOrders}
                          onChange={this.onChange('allowAnonymousOrders', true)}
                          valueToRender={data.allowAnonymousOrders ? 'Enabled' : 'Disabled'}
                          editMode={editMode}
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                        Requires Valid Recommendation
                      </Grid>
                      <Grid className="editField" item xs={12} sm={2} md={2} lg={1}>
                        <EditableSwitch
                          valueToRender={data.requireValidRecDate ? 'Enabled' : 'Disabled'}
                          checked={data.requireValidRecDate}
                          editMode={editMode}
                          onChange={this.onChange('requireValidRecDate', true)}
                        />
                      </Grid>
                      <Grid className="editField" item xs={12} sm={4} md={4} lg={5}>
                        <span>
                          When enabled, medicinal members/patients are required to have an existing
                          recommendation with a non-expired expiration date.
                        </span>
                      </Grid>
                    </Grid>
                  </ListItem>

                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                        Enable Tip
                      </Grid>
                      <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                        <EditableSwitch
                          valueToRender={data.enableTip ? 'Enabled' : 'Disabled'}
                          checked={data.enableTip}
                          editMode={editMode}
                          onChange={this.onChange('enableTip', true)}
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                        Enable Refund Note
                      </Grid>
                      <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                        <EditableSwitch
                          valueToRender={data.enableRefundNote ? 'Enabled' : 'Disabled'}
                          checked={data.enableRefundNote}
                          editMode={editMode}
                          onChange={this.onChange('enableRefundNote', true)}
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                        Checkout Process
                      </Grid>
                      <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                        <EditableSelect
                          value={data.checkoutType || 1}
                          onChange={this.onChange('checkoutType')}
                          valueToRender={data.checkoutType || 1}
                          editMode={editMode}
                          displayEmpty={true}
                        >
                          <MenuItem value={'Direct'}>Direct</MenuItem>
                          <MenuItem value={'Fulfillment'}>Fulfillment</MenuItem>
                          <MenuItem value={'FulfillmentThreeStep'}>Fulfillment Three Step</MenuItem>
                        </EditableSelect>
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                        Enable auto-print when send to fulfillment
                      </Grid>
                      <Grid className="editField" item xs={12} sm={2} md={2} lg={1}>
                        <EditableSwitch
                          valueToRender={data.enableAutoPrintAtFulfillment ? 'Enabled' : 'Disabled'}
                          checked={data.enableAutoPrintAtFulfillment}
                          editMode={editMode}
                          onChange={this.onChange('enableAutoPrintAtFulfillment', true)}
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                  {data.appTarget === 'Distribution' ? (
                    <ListItem>
                      <Grid container>
                        <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                          Auto Mark Received Batches As
                        </Grid>
                        <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                          <EditableSelect
                            value={data.receiveBatchStatus || ''}
                            onChange={this.onChange('receiveBatchStatus')}
                            valueToRender={
                              (data.receiveBatchStatus &&
                                data.receiveBatchStatus.replace(/_/g, ' ')) ||
                              ''
                            }
                            editMode={editMode}
                            displayEmpty={true}
                          >
                            <MenuItem value="">Select</MenuItem>
                            <MenuItem value="RECEIVED">Received</MenuItem>
                            <MenuItem value="IN_TESTING">In Testing</MenuItem>
                            <MenuItem value="READY_FOR_SALE">Ready for Sale</MenuItem>
                          </EditableSelect>
                        </Grid>
                      </Grid>
                    </ListItem>
                  ) : null}
                  {allowDelivery ? (
                    <ListItem>
                      <Grid container>
                        <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                          Require Delivery Signature
                        </Grid>
                        <Grid className="editField" item xs={12} sm={2} md={2} lg={1}>
                          <EditableSwitch
                            valueToRender={data.enableDeliverySignature ? 'Enabled' : 'Disabled'}
                            checked={data.enableDeliverySignature}
                            editMode={editMode}
                            onChange={this.onChange('enableDeliverySignature', true)}
                          />
                        </Grid>
                        <Grid className="editField" item xs={12} sm={4} md={4} lg={5}>
                          <span>
                            When enabled, patient/member signature is required upon delivery.
                          </span>
                        </Grid>
                      </Grid>
                    </ListItem>
                  ) : null}
                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                        Prepend brand name for weedmap sync
                      </Grid>
                      <Grid className="editField switch_btn" item xs={12} sm={2} md={2} lg={1}>
                        <EditableSwitch
                          valueToRender={data.appendBrandNameWM ? 'Enabled' : 'Disabled'}
                          checked={data.appendBrandNameWM}
                          editMode={editMode}
                          onChange={this.onChange('appendBrandNameWM', true)}
                        />
                      </Grid>
                      <Grid className="editField" item xs={12} sm={4} md={4} lg={5}>
                        <span>
                          When enable then prepend brand name to product name while syncing at
                          weedmap
                        </span>
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                        Product Information Batch Sourcing Strategy
                      </Grid>
                      <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                        <EditableSelect
                          value={productInfoSourcingStrategyValue}
                          onChange={this.onChange('productInfoSourcingStrategy')}
                          valueToRender={
                            productInfoSourcingStrategyLabels[productInfoSourcingStrategyValue]
                          }
                          editMode={editMode}
                        >
                          {Object.entries(productInfoSourcingStrategyLabels).map(
                            ([value, label]) => (
                              <MenuItem key={value} value={value}>
                                {label}
                              </MenuItem>
                            ),
                          )}
                        </EditableSelect>
                      </Grid>
                    </Grid>
                  </ListItem>
                  {isMedicinalShop && showConsumerTypeRestriction ? (
                    <ListItem>
                      <Grid container>
                        <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                          Restrict adult-use members
                        </Grid>
                        <Grid className="editField switch_btn" item xs={12} sm={2} md={2} lg={1}>
                          <EditableSwitch
                            valueToRender={
                              shopInfoSettings['enableAdultUse'] ? 'Enabled' : 'Disabled'
                            }
                            checked={shopInfoSettings['enableAdultUse']}
                            editMode={editMode}
                            onChange={this.updateShopInformation('enableAdultUse', true)}
                          />
                        </Grid>
                      </Grid>
                    </ListItem>
                  ) : null}
                </Paper>
              </Grid>
            )}
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Paper className="paper-page">
                <ListItem>
                  <Grid container>
                    <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                      Enable Customer Identification
                    </Grid>
                    <Grid className="editField" item xs={12} sm={2} md={2} lg={1}>
                      <EditableSwitch
                        valueToRender={data.enableCustomerIdentification ? 'Enabled' : 'Disabled'}
                        checked={data.enableCustomerIdentification}
                        editMode={editMode}
                        onChange={this.onChange('enableCustomerIdentification', true)}
                      />
                    </Grid>
                  </Grid>
                </ListItem>
                {!isGrowShop ? (
                  <Fragment>
                    <ListItem>
                      <Grid container>
                        <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                          Enable Driver assignment in Dispatch for Tookan
                        </Grid>
                        <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                          <EditableSwitch
                            valueToRender={data.tookanRequired ? 'Enabled' : 'Disabled'}
                            checked={data.tookanRequired}
                            editMode={editMode}
                            onChange={this.onChange('tookanRequired', true)}
                          />
                        </Grid>
                      </Grid>
                    </ListItem>
                    <ListItem>
                      <Grid container>
                        <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                          Enable Duplicate License Check
                        </Grid>
                        <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                          <EditableSwitch
                            valueToRender={data.checkDuplicateDl ? 'Enabled' : 'Disabled'}
                            checked={data.checkDuplicateDl}
                            editMode={editMode}
                            onChange={this.onChange('checkDuplicateDl', true)}
                          />
                        </Grid>
                      </Grid>
                    </ListItem>
                    <ListItem>
                      <Grid container>
                        <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                          Enable DOB Name Uniqueness
                        </Grid>
                        <Grid className="editField switch_btn" item xs={12} sm={2} md={2} lg={1}>
                          <EditableSwitch
                            valueToRender={data.enableDOBNameUniqueness ? 'Enabled' : 'Disabled'}
                            checked={data.enableDOBNameUniqueness}
                            editMode={editMode}
                            onChange={this.onChange('enableDOBNameUniqueness', true)}
                          />
                        </Grid>
                        <Grid
                          className="editField"
                          item
                          xs={12}
                          sm={4}
                          md={4}
                          lg={5}
                          style={{ wordBreak: 'break-word' }}
                        >
                          <span>
                            When enabled, the system will check for uniqueness based on first name,
                            last name, and dob
                          </span>
                        </Grid>
                      </Grid>
                    </ListItem>
                    {allowDelivery ? (
                      <ListItem>
                        <Grid container>
                          <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                            Enable Waive Signature for Delivery Transactions
                          </Grid>
                          <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                            <EditableSwitch
                              valueToRender={data.enableWaive ? 'Enabled' : 'Disabled'}
                              checked={data.enableWaive}
                              editMode={editMode}
                              onChange={this.onChange('enableWaive', true)}
                            />
                          </Grid>
                        </Grid>
                      </ListItem>
                    ) : null}
                    <ListItem>
                      <Grid container>
                        <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                          Enable Item Discount Notes
                        </Grid>
                        <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                          <EditableSwitch
                            valueToRender={data.enableDiscountNotes ? 'Enabled' : 'Disabled'}
                            checked={data.enableDiscountNotes}
                            editMode={editMode}
                            onChange={this.onChange('enableDiscountNotes', true)}
                          />
                        </Grid>
                      </Grid>
                    </ListItem>
                    <ListItem>
                      <Grid container>
                        <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                          Enable Cart Discount Notes
                        </Grid>
                        <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                          <EditableSwitch
                            valueToRender={data.enableCartDiscountNotes ? 'Enabled' : 'Disabled'}
                            checked={data.enableCartDiscountNotes}
                            editMode={editMode}
                            onChange={this.onChange('enableCartDiscountNotes', true)}
                          />
                        </Grid>
                      </Grid>
                    </ListItem>
                    <ListItem>
                      <Grid container>
                        <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                          Enable After Tax Discount Notes
                        </Grid>
                        <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                          <EditableSwitch
                            valueToRender={
                              data.enableAfterTaxDiscountNotes ? 'Enabled' : 'Disabled'
                            }
                            checked={data.enableAfterTaxDiscountNotes}
                            editMode={editMode}
                            onChange={this.onChange('enableAfterTaxDiscountNotes', true)}
                          />
                        </Grid>
                      </Grid>
                    </ListItem>
                    <ListItem>
                      <Grid container>
                        <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                          Enable BCC Receipt
                        </Grid>
                        <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                          <EditableSwitch
                            valueToRender={data.enableBCCReceipt ? 'Enabled' : 'Disabled'}
                            checked={data.enableBCCReceipt}
                            editMode={editMode}
                            onChange={this.onChange('enableBCCReceipt', true)}
                          />
                        </Grid>
                      </Grid>
                    </ListItem>
                  </Fragment>
                ) : null}
                {data.enableBCCReceipt ? (
                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                        BCC Receipt Email
                      </Grid>
                      <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                        <EditableReactSelectCreatable
                          multi={true}
                          value={
                            (data.bccEmailAddress &&
                              data.bccEmailAddress.trim() &&
                              data.bccEmailAddress.split(', ').map((email) => ({
                                label: email,
                                value: email,
                              }))) ||
                            []
                          }
                          onChange={this.onChangeBccEmail}
                          valueToRender={
                            (data.bccEmailAddress && data.bccEmailAddress.trim()) || ''
                          }
                          editMode={editMode}
                          options={[]}
                          clearable={false}
                          placeholder="Enter email to receive BCC receipts"
                          simpleValue
                          delimiter=", "
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                ) : null}
                <ListItem>
                  <Grid container>
                    <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                      Enable Low Inventory Email
                    </Grid>
                    <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                      <EditableSwitch
                        valueToRender={data.enableLowInventoryEmail ? 'Enabled' : 'Disabled'}
                        checked={data.enableLowInventoryEmail}
                        editMode={editMode}
                        onChange={this.onChange('enableLowInventoryEmail', true)}
                      />
                    </Grid>
                  </Grid>
                </ListItem>
                <ListItem>
                  <Grid container>
                    <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                      Legal Language for Product Labels
                    </Grid>
                    <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                      <EditableTextField
                        valueToRender={data.legalLanguage || ''}
                        value={data.legalLanguage || ''}
                        editMode={editMode}
                        onChange={this.onChange('legalLanguage')}
                        placeholder="Enter Legal Language for Product Labels"
                      />
                    </Grid>
                  </Grid>
                </ListItem>
                <ListItem>
                  <Grid container>
                    <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                      Skip Inventory validation on Assignment
                    </Grid>
                    <Grid className="editField" item xs={12} sm={2} md={2} lg={1}>
                      <EditableSwitch
                        valueToRender={data.enableSkipAssignValidation ? 'Enabled' : 'Disabled'}
                        checked={data.enableSkipAssignValidation}
                        editMode={editMode}
                        onChange={this.onChange('enableSkipAssignValidation', true)}
                      />
                    </Grid>
                    <Grid className="editField" item xs={12} sm={4} md={4} lg={5}>
                      <span>
                        When enabled, you will be able to assign orders to an employee regardless of
                        their Assigned Terminal's current inventory quantities.
                      </span>
                    </Grid>
                  </Grid>
                </ListItem>
                {data.address && data.address.state === 'MI' ? (
                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                        Enable Excise Tax Pop-Up Warning
                      </Grid>
                      <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                        <EditableSwitch
                          valueToRender={data.enableExciseTaxWarning ? 'Enabled' : 'Disabled'}
                          checked={data.enableExciseTaxWarning}
                          editMode={editMode}
                          onChange={this.onChange('enableExciseTaxWarning', true)}
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                ) : null}
                {data.address && data.address.state === 'MI' && data.enableExciseTaxWarning ? (
                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                        Notification Excise Tax Pop-Up Warning
                      </Grid>
                      <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                        <EditableTextField
                          valueToRender={data.exciseTaxWarning || ''}
                          value={data.exciseTaxWarning || ''}
                          editMode={editMode}
                          onChange={this.onChange('exciseTaxWarning')}
                          placeholder="Enter Pop-Up Warning"
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                ) : null}
              </Paper>
            </Grid>
            {data.appTarget !== 'Grow' && (
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Paper className="paper-page">
                  {allowDelivery ? (
                    <ListItem>
                      <Grid container>
                        <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                          Enforce GPS Delivery Tracking (Available on v2.7.0+)
                        </Grid>
                        <Grid className="editField" item xs={12} sm={2} md={2} lg={1}>
                          <EditableSwitch
                            valueToRender={data.enableGPSTracking ? 'Enabled' : 'Disabled'}
                            checked={data.enableGPSTracking}
                            editMode={editMode}
                            onChange={this.onChange('enableGPSTracking', true)}
                          />
                        </Grid>
                        <Grid className="editField" item xs={12} sm={4} md={4} lg={5}>
                          <span>
                            When enabled, iPhones and iPads will be required to have their devices
                            location enabled. The system will then track the iPhone/iPad's GPS
                            location.
                          </span>
                        </Grid>
                      </Grid>
                    </ListItem>
                  ) : null}
                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                        Restricted views
                      </Grid>
                      <Grid className="editField" item xs={12} sm={2} md={2} lg={1}>
                        <EditableSwitch
                          valueToRender={data.restrictedViews ? 'Enabled' : 'Disabled'}
                          checked={data.restrictedViews}
                          editMode={editMode}
                          onChange={this.onChange('restrictedViews', true)}
                        />
                      </Grid>
                      <Grid className="editField" item xs={12} sm={4} md={4} lg={5}>
                        <span>
                          When enabled, budtenders and drivers will only see cash drawers,
                          transactions, and members that are assigned or related to them.
                        </span>
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                        Enable Auto Cash Drawers
                      </Grid>
                      <Grid className="editField" item xs={12} sm={2} md={2} lg={1}>
                        <EditableSwitch
                          valueToRender={data.autoCashDrawer ? 'Enabled' : 'Disabled'}
                          checked={data.autoCashDrawer}
                          editMode={editMode}
                          onChange={this.onChange('autoCashDrawer', true)}
                        />
                      </Grid>
                      <Grid className="editField" item xs={12} sm={4} md={4} lg={5}>
                        <span>
                          When enabled, cash drawer sessions are automatically created for the new
                          day. The previous day cash drawer session's expected amount will carry
                          over to the new day's session.
                        </span>
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                        Enforce Cash Drawers for Sales
                      </Grid>
                      <Grid className="editField" item xs={12} sm={2} md={2} lg={1}>
                        <EditableSwitch
                          valueToRender={data.enforceCashDrawers ? 'Enabled' : 'Disabled'}
                          checked={data.enforceCashDrawers}
                          editMode={editMode}
                          onChange={this.onChange('enforceCashDrawers', true)}
                        />
                      </Grid>
                      <Grid className="editField" item xs={12} sm={4} md={4} lg={5}>
                        <span>
                          When enabled, cash drawers need to exists for the terminal that the sales
                          are made.
                        </span>
                      </Grid>
                    </Grid>
                  </ListItem>
                  {tripShareInventoriesFlag && companyFeatures.enableTripDeliveryLedger && (
                    <ListItem>
                      <Grid container>
                        <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                          Allow shared inventories for trips
                        </Grid>
                        <Grid className="editField" item xs={12} sm={2} md={2} lg={1}>
                          <EditableSwitch
                            valueToRender={
                              complianceSettings.allowSharedInventoriesTrip ? 'Enabled' : 'Disabled'
                            }
                            checked={complianceSettings.allowSharedInventoriesTrip}
                            editMode={editMode}
                            onChange={this.updateComplianceSettings(
                              'allowSharedInventoriesTrip',
                              true,
                            )}
                          />
                        </Grid>
                        <Grid className="editField" item xs={12} sm={4} md={4} lg={5}>
                          <span>
                            When enabled, drivers can start trips with the same assigned inventory.
                          </span>
                        </Grid>
                      </Grid>
                    </ListItem>
                  )}
                  <ListItem>
                    <Grid container>
                      <Grid className="labelField flex-center" item xs={12} sm={6} md={6} lg={6}>
                        Terminal Sales Allocation &nbsp;
                        <TermSalesTooltip />
                      </Grid>
                      <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                        <EditableSelect
                          value={data.termSalesOption}
                          onChange={this.onChange('termSalesOption')}
                          valueToRender={data.termSalesOption}
                          editMode={editMode}
                          displayEmpty={true}
                        >
                          <MenuItem value="DeviceTerminal">By Active Device Terminal</MenuItem>
                          <MenuItem value="AssignedEmployeeTerminal">
                            To Assigned Employee's Terminal
                          </MenuItem>
                          <MenuItem value="SellerAssignedTerminal">
                            To Assigned Terminal of Employee Who Completed the Transaction
                          </MenuItem>
                        </EditableSelect>
                      </Grid>
                    </Grid>
                  </ListItem>
                  {availableApps.length > 0 &&
                    availableApps &&
                    availableApps.indexOf('Dispatch') >= 0 && (
                      <ListItem>
                        <Grid container>
                          <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                            Max Orders for Driver view
                          </Grid>
                          <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                            <EditableNumericInput
                              placeholder=""
                              valueToRender={`${data.deliveryMaxOrders || 1}`}
                              value={data.deliveryMaxOrders}
                              className="numeric-material-input"
                              mobile={false}
                              onChange={this.onChangeNumber('deliveryMaxOrders')}
                              min={1}
                              precision={0}
                              editMode={editMode}
                            />
                          </Grid>
                        </Grid>
                      </ListItem>
                    )}
                  {availableApps.length > 0 &&
                    availableApps &&
                    availableApps.indexOf('Dispatch') >= 0 && (
                      <ListItem>
                        <Grid container>
                          <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                            Enable Deferring for Delivery Transactions
                          </Grid>
                          <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                            <EditableSwitch
                              valueToRender={data.enableDeferTransactions ? 'Enabled' : 'Disabled'}
                              checked={data.enableDeferTransactions}
                              editMode={editMode}
                              onChange={this.onChange('enableDeferTransactions', true)}
                            />
                          </Grid>
                        </Grid>
                      </ListItem>
                    )}
                  <ListItem>
                    {availableApps.length > 0 &&
                    availableApps &&
                    availableApps.indexOf('Dispatch') >= 0 ? (
                      <Grid container>
                        <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                          Draft Order Timeout (min)
                        </Grid>
                        <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                          <EditableNumericInput
                            placeholder=""
                            valueToRender={`${
                              data.draftOrderTimeout || data.draftOrderTimeout
                            } mins`}
                            value={data.draftOrderTimeout}
                            className="numeric-material-input"
                            mobile={false}
                            onChange={this.onChangeNumber('draftOrderTimeout')}
                            min={0}
                            precision={0}
                            editMode={editMode}
                          />
                        </Grid>
                      </Grid>
                    ) : null}
                  </ListItem>
                </Paper>
              </Grid>
            )}
            {data.appTarget !== 'Grow' && (
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Paper className="paper-page">
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Typography className="margin-left-small" variant="headline">
                      Queue Management
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <ListItem>
                      <Grid container>
                        <Grid className="labelField" item xs={4}>
                          <Typography variant="title" gutterBottom>
                            Queue Name
                          </Typography>
                        </Grid>
                        <Grid className="editField" item xs={4}>
                          <Typography variant="title" gutterBottom>
                            Status
                          </Typography>
                        </Grid>
                        <Grid className="editField" item xs={4}>
                          <Typography variant="title" gutterBottom>
                            Device Order Validation
                          </Typography>
                        </Grid>
                      </Grid>
                    </ListItem>
                    {queueTypes.map((queue, index) => {
                      return (
                        <ListItem key={index}>
                          <Grid container>
                            <Grid className="labelField" item xs={4}>
                              {queue.name}
                            </Grid>
                            <Grid className="editField" item xs={4}>
                              <EditableSwitch
                                valueToRender={data[queue.show] ? 'Enabled' : 'Disabled'}
                                checked={data[queue.show]}
                                editMode={editMode}
                                onChange={this.onChange(queue.show, true)}
                              />
                            </Grid>
                            <Grid className="editField" item xs={4}>
                              <EditableSelect
                                value={data[queue.dov] || 'ByTerminal'}
                                onChange={this.onChange(queue.dov)}
                                valueToRender={data[queue.dov] || 'By Terminal'}
                                editMode={editMode}
                                displayEmpty={true}
                              >
                                <MenuItem value="ByTerminal">By Terminal</MenuItem>
                                {companyFeatures.orderDeviceInventoryValidation && (
                                  <MenuItem value="ByInventory">By Inventory</MenuItem>
                                )}
                              </EditableSelect>
                            </Grid>
                          </Grid>
                        </ListItem>
                      )
                    })}
                  </Grid>
                </Paper>
              </Grid>
            )}
            {data.appTarget !== 'Retail' && (
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Paper className="paper-page">
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Typography className="margin-left-small" variant="headline">
                      Compliance Testing
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <ListItem>
                      <Grid container>
                        <Grid className="labelField" item xs={6} sm={6} md={6} lg={6}>
                          Enable Compliance Testing
                        </Grid>
                        <Grid className="editField" item xs={6} sm={6} md={6} lg={6}>
                          <EditableSwitch
                            valueToRender={data.enableComplianceTesting ? 'Enabled' : 'Disabled'}
                            checked={data.enableComplianceTesting}
                            editMode={editMode}
                            onChange={this.onChange('enableComplianceTesting', true)}
                          />
                        </Grid>
                      </Grid>
                    </ListItem>
                  </Grid>
                </Paper>
              </Grid>
            )}
            {data.appTarget !== 'Retail' && data.canAssignLocationsToPackages && (
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Paper className="paper-page">
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Typography className="margin-left-small" variant="headline">
                      Metrc Packages Location
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    {data.defaultMetrcLocation ? (
                      <div>
                        <ListItem>
                          <Grid container>
                            <Grid className="labelField" item xs={6} sm={6} md={6} lg={6}>
                              <Typography>Default Location</Typography>
                            </Grid>
                            <Grid className="editField" item xs={6} sm={6} md={6} lg={6}>
                              <EditableTextField
                                valueToRender={data.defaultMetrcLocation.Name || ''}
                                value={data.defaultMetrcLocation.Name || ''}
                                onChange={this.onChange('metrcPackageDefaultLocation')}
                                placeholder="Enter metrc package default location name"
                              />
                            </Grid>
                          </Grid>
                        </ListItem>
                        <ListItem>
                          <Grid container>
                            <Grid className="labelField" item xs={6} sm={6} md={6} lg={6}>
                              <Typography>Location Type</Typography>
                            </Grid>
                            <Grid className="editField" item xs={6} sm={6} md={6} lg={6}>
                              <EditableTextField
                                valueToRender={data.defaultMetrcLocation.LocationTypeName || ''}
                                value={data.defaultMetrcLocation.LocationTypeName || ''}
                                onChange={this.onChange('metrcPackageDefaultLocation')}
                                placeholder="Enter metrc package default location name"
                              />
                            </Grid>
                          </Grid>
                        </ListItem>
                      </div>
                    ) : (
                      <ListItem>
                        <Grid container>
                          <Grid className="labelField" xs={12} sm={6} md={6} item lg={6}>
                            Default metrc location not set!
                          </Grid>
                          <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                            {editMode == true ? (
                              <EditActionComponent
                                onSave={this.onSubmitMetrcPackageLocation}
                                onCancel={this.toggleCreateLocation}
                                onEdit={this.toggleCreateLocation}
                                editMode={creatingLocationMode}
                                editTitle={'Create'}
                              />
                            ) : null}
                          </Grid>
                        </Grid>
                      </ListItem>
                    )}
                    {creatingLocationMode ? (
                      <div>
                        <ListItem>
                          <Grid container>
                            <Grid className="labelField" item xs={6} sm={6} md={6} lg={6}>
                              <Typography>Default Location</Typography>
                            </Grid>
                            <Grid className="editField" item xs={6} sm={6} md={6} lg={6}>
                              <EditableTextField
                                valueToRender={newLocationName || ''}
                                value={newLocationName || ''}
                                //onChange={this.onChange('metrcPackageDefaultLocation')}
                                onChange={this.onChangeLocation()}
                                placeholder="Enter metrc package default location name"
                                editMode={creatingLocationMode}
                              />
                            </Grid>
                          </Grid>
                        </ListItem>
                        <ListItem>
                          <Grid container>
                            <Grid className="labelField" item xs={6} sm={6} md={6} lg={6}>
                              <Typography>Default Location Type</Typography>
                            </Grid>
                            <Grid className="editField" item xs={6} sm={6} md={6} lg={6}>
                              <EditableSelect
                                value={newLocationTypeName}
                                onChange={this.onChangeLocationType()}
                                valueToRender={newLocationTypeName}
                                editMode={creatingLocationMode}
                                displayEmpty={true}
                              >
                                <MenuItem value="">Select Metrc location type</MenuItem>
                                {metrcLocationTypes &&
                                  metrcLocationTypes.length &&
                                  metrcLocationTypes.map((type, index) => {
                                    return (
                                      <MenuItem value={type.Name} key={index}>
                                        {type.Name}
                                      </MenuItem>
                                    )
                                  })}
                              </EditableSelect>
                            </Grid>
                          </Grid>
                        </ListItem>
                      </div>
                    ) : null}
                  </Grid>
                </Paper>
              </Grid>
            )}
            {availableApps &&
              availableApps.length > 0 &&
              availableApps.indexOf('Worker') >= 0 &&
              data.appTarget === 'Distribution' && (
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Paper className="paper-page">
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <Typography className="margin-left-small" variant="headline">
                        Manufacturing
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <ListItem>
                        <Grid container>
                          <Grid className="labelField" item xs={6} sm={6} md={6} lg={6}>
                            Enable Manufacturing
                          </Grid>
                          <Grid className="editField" item xs={6} sm={6} md={6} lg={6}>
                            <EditableSwitch
                              valueToRender={data.enableMfg ? 'Enabled' : 'Disabled'}
                              checked={data.enableMfg}
                              editMode={editMode}
                              onChange={this.onChange('enableMfg', true)}
                            />
                          </Grid>
                        </Grid>
                      </ListItem>
                    </Grid>
                  </Paper>
                </Grid>
              )}
          </Grid>
        </Grid>
      </div>
    )
  }
}

export default connect(({ companyReducer, thirdPartyReducer, authReducer, ...state }) => ({
  dispatch: state.dispatch,
  companyReducer,
  thirdPartyReducer,
  authReducer,
}))(ShopInfo)



// WEBPACK FOOTER //
// ./src/components/Shops/ShopInfo.js